// import React from "react";
// import QRCode from "qrcode.react";

// const QRCodeGenerator = (props) => {
//     return (
//       <div>
//         {props.value &&
//           <QRCode value={props.value} />
//         }
//       </div>
//     );
//   };
  
//   export default QRCodeGenerator;

import React from "react";
import QRCode from "qrcode.react";

const QRCodeGenerator = ({ value }) => {
  if (!value || value.trim() === "") return null;

  return (
    <QRCode
      value={value}
      size={200}
      level="H"
      includeMargin={true}
    />
  );
};

export default QRCodeGenerator;
